import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { LOCATION_CHANGE } from '@sde/widgets-core/src/redux/router/actions';
import uniqBy from 'lodash/uniqBy';
import { ADD_ALERT, REMOVE_ALERT, SHOW_ALERT, CLEAR_ALERTS } from './constants';

const initialState = {
  count: 0,
  list: [],
};

export const alertsReducer = createReducer(initialState, {
  [ADD_ALERT]: (state, action) => {
    const newList = uniqBy(state.list.concat(action.payload || []), 'message');

    return {
      count: newList.length,
      list: newList,
    };
  },

  [REMOVE_ALERT]: (state, action) => {
    const newList = state.list.filter((x, i) => i !== action.payload);

    return {
      count: newList.length,
      list: newList,
    };
  },

  [SHOW_ALERT]: (state, action) => {
    return {
      count: 1,
      list: [action.payload],
    };
  },

  [CLEAR_ALERTS]: () => {
    return initialState;
  },

  [LOCATION_CHANGE]: () => {
    return initialState;
  },
});
